import styled, { css } from 'styled-components';

import { pxToRem } from '../../../utils/styles';

export const ServicesListWrapper = styled.ul<{ $widgetType?: string }>`
  &&& {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: ${pxToRem(48)};
    padding-inline-start: ${pxToRem(16)};
    margin: 0;

    ${({ $widgetType }) =>
      $widgetType === 'embedded' &&
      css`
        list-style-type: none;
        padding: 0;
        column-gap: 0;
        padding-inline-start: 0;
      `}

    ${({ theme: { mediaQueries } }) =>
      (mediaQueries.isDesktopSmall ||
        mediaQueries.isTablet ||
        mediaQueries.isMobile) &&
      css`
        grid-template-columns: repeat(1, 1fr);
        gap: ${pxToRem(8)};
      `}
  }
`;
export const ServiceElement = styled.div`
  &&& {
    display: flex;
    gap: ${pxToRem(8)};
  }
`;

export const ServiceWrapperLi = styled.li`
  &&& {
  }
`;

export const TitleWrapper = styled.div`
  &&& {
    display: flex;
    gap: ${pxToRem(8)};
    justify-content: flex-start;
  }
`;

export const ServicesListSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(16)};
`;

export const TooltipContent = styled.div`
  &&& {
    padding: ${pxToRem(24)};
    max-width: ${pxToRem(300)};
  }
`;
